import { extendTheme } from "@chakra-ui/react";

const theme = {
  styles: {
    global: {
      "html, body": {
        color: "white",
        background: "#000E11",
        fontFamily: "Roboto, sans-serif",
      },
      "html, body, button + input": {
        fontFamily: "Roboto, sans-serif",
      },
    },
  },
};

export default extendTheme(theme);
